module.exports = __webpack_public_path__ + "img/presenter_shirabe@2x.5de81234.jpg";